/**
 * @file The Form Child component.
 * @author Heino Lenting
*/
import * as tslib_1 from "tslib";
import { FormChildBase } from '../../base/form-child/form-child.base';
import { DomainService } from '../../domain.service';
import { TranslateService } from '@ngx-translate/core';
import { AlertsService } from '../../core/alerts.service';
import { ResourceService } from '../../resource.service';
var FormChildComponent = /** @class */ (function (_super) {
    tslib_1.__extends(FormChildComponent, _super);
    /**
     * Constructs a FormChildComponent
     * @param configurationsService Service to get the configuration of this component.
     * @param domainService Service to access entities form the backend entity api.
     */
    function FormChildComponent(domainService, translateService, alertsService, resourceService) {
        return _super.call(this, domainService, translateService, alertsService, resourceService) || this;
    }
    /**
     * Gets whether or not the form is readonly.
     * Is used for the isReadOnly and to override properly.
     * Typescript super key word does not give access for properties.
     * @protected
     * @returns {boolean} Value whether or not the form is readonly.
     * @memberOf FormChildComponent
     */
    FormChildComponent.prototype.getIsReadOnly = function () {
        if (this.editMode && this.item && this.item.entityType.shortName === 'Taskneed' && this.master) {
            if (this.master['Oid'] !== this.item['Owner_Oid']) {
                // Issue: Je kan niet zien of de aanwezigheid goed is aangemaakt #2786
                return true;
            }
        }
        return _super.prototype.getIsReadOnly.call(this);
    };
    return FormChildComponent;
}(FormChildBase));
export { FormChildComponent };
